import HttpError from './HttpError';
import * as fetchUtils from './fetchUtils';
import { getHeaders, reauthenticateIfNeeded } from './tokensHelper';

const mergeAuthHeaders = optionHeaders => {
  const headers = getHeaders(true);
  if (optionHeaders) {
    new Headers(optionHeaders).forEach((value, key) => {
      headers.set(key, value);
    });
  }
  return headers;
};

const fetchWrapper = async (...params) => {
  const result = await fetch(...params);

  const { status } = result;

  if (status < 200 || status >= 300) {
    let message = result.statusText;
    let body = null;
    try {
      const text = await result.text();
      body = text;
      try {
        const json = JSON.parse(text);
        body = json;
        message = json.message || json.messages || message;
      } catch (e) {
        if (text) message = text;
      }
    } catch (e) {
      /* keep statusText */
    }
    throw new HttpError(message, status, body);
  }

  return result;
};

export const httpClient = ({ apiAuthUrl, permissionsUrl, clearTokens, saveTokens }) => async (
  url,
  options = {},
  fetchJson = true,
) => {
  const fetchMethod = fetchJson ? fetchUtils.fetchJson : fetchWrapper;

  const request = () =>
    fetchMethod(url, {
      ...options,
      headers: mergeAuthHeaders(options.headers),
    });

  try {
    return await request();
  } catch (error) {
    if (
      error.status === 401 &&
      (await reauthenticateIfNeeded({ apiAuthUrl, permissionsUrl }, error.status, {
        clearTokensData: clearTokens,
        saveTokensData: saveTokens,
      }))
    ) {
      return request();
    }

    throw error;
  }
};

// this method use only for auth provider
export const sendData = async (
  method,
  url,
  authorizationUrl,
  permissionsUrl,
  params,
  saveTokens,
  clearTokens,
  errorMessage,
) => {
  try {
    const response = await fetchUtils.fetchJson(url, {
      method,
      body: JSON.stringify(params),
      headers: getHeaders(false),
    });
    return response.json;
  } catch (e) {
    if (e.status === 400) {
      // eslint-disable-next-line no-throw-literal
      throw new Error(errorMessage);
    }

    if (e.status < 200 || e.status >= 300) {
      throw e;
    }
  }
};

// this method use only for login
export const authLogin = async (url, params, saveTokens, loginErrorMessage) => {
  const request = new Request(url, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: getHeaders(false),
  });
  let json;

  const response = await fetch(request);

  if (response.status === 401) {
    // eslint-disable-next-line no-throw-literal
    throw new Error(loginErrorMessage);
  }

  if (response.status < 200 || response.status >= 300) {
    const body = await response.text();
    try {
      json = JSON.parse(body);
    } catch (e) {
      json = body;
    }
    throw new HttpError(json && (json.message || json.messages), response.status, json);
  }

  const data = await response.json();
  saveTokens(data);
};
